import IngredientResults from './IngredientResults';
export default IngredientResults;
